module.exports = __webpack_public_path__ + "static/img/5-2.a305e93c.png";